/**
@description 设置路由路径
*/
import About from './About'
import SinglePage from 'components/page/SinglePage'
import NewsList from './NewsList'
import LoanInfoList from './LoanInfoList'
import NewsDetail from './NewsDetail'
import ShopAddress from './ShopAddress'
import Announcement from './Announcement'
import AnnouncementList from './AnnouncementList'
import AnnouncementDetail from './AnnouncementDetail'
import Honor from './Honor'


export const aboutUsRouting = [
  {
    path: 'aboutUs',
    component: About,
    name: '关于我们',
    indexRoute: {
      name: '公司介绍',
      component: SinglePage,
      title: '公司介绍-关于我们',
      catname: 'company'
    },
    childRoutes: [
      {
        path: 'company',
        name: '公司介绍',
        title: '公司介绍-关于我们',
        component: SinglePage
      }, {
        path: 'shareholder',
        name: '股东介绍',
        title: '股东介绍-关于我们',
        component: SinglePage
      }, {
        path: 'management',
        name: '高管团队',
        title: '高管团队-关于我们',
        component: SinglePage
      }, {
        path: 'partner',
        name: '合作机构',
        title: '合作机构-关于我们',
        component: SinglePage
      }, {
        path: 'responsibility',
        name: '社会责任',
        title: '社会责任-关于我们',
        component: SinglePage
      },{
        path: 'news',
        name: '新闻动态',
        component: NewsList,
      },
      {
        path: 'newsinfo/:id',
        name: '新闻动态',
        component: NewsList,
      },{
        path: 'news/:id',
        name: '正文',
        component: NewsDetail
      }, {
        path: 'announcement',
        name: '公司公告',
        component: AnnouncementList,
      }, {
        path: 'announcementDetail/:id',
        name: '正文',
        component: AnnouncementDetail
      }, {
        path: 'honor',
        name: '公司荣誉',
        component: Honor
      }, {
        path: 'shopAddress',
        name: '门店地址',
        component: ShopAddress
      }, {
        path: 'loaninfo/:id',
        name: '借款资讯',
        component: LoanInfoList
      }, {
        path: 'loaninfodetail/:id',
        name: '正文',
        component: NewsDetail
      },
    ]
  }
]



// WEBPACK FOOTER //
// ./modules/aboutUs/routing.js